import { getFullPath, routes } from "../../../routes";
import { Navigate } from "react-router";
import { TransferForm } from "./TransferForm";
import { useQualifierUser } from "@/queries/user.queries";

export function OwnershipTransfer() {
  const user = useQualifierUser();

  if (user.isLoading) {
    return <p>Loading...</p>;
  } else if (user.isError) {
    return <p>An unknown error occurred.</p>;
  } else if (user.isSuccess) {
    return <TransferForm user={user.data} />;
  } else {
    return <Navigate to={getFullPath(routes.user.transferOwnership)} />;
  }
}
